import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box } from "@material-ui/core";
import ChequeContractStep3Form from "./ChequeContractStep3/ChequeContractStep3Form";

const ChequeContractStep3 = (props) => {
  return (
    <Wrapper>
      <Box pb={2}>
        <ChequeContractStep3Form
          percent={props.percent}
          firstCheques={props.firstCheque}
          secondCheques={props.secondCheque}
          setStep={props.setStep}
          data={props.data}
          isEdit={props.isEdit}
          originDate={props.originDate}
          setOriginDate={props.setOriginDate}
        />
      </Box>
      {/*<Box pb={2}>*/}
      {/*    <Card>*/}
      {/*        <CardContent>*/}
      {/*            <ChequeContractStep3List*/}
      {/*                title={"چک های خروجی"}*/}
      {/*                cheques={props.firstCheque}*/}
      {/*            />*/}
      {/*        </CardContent>*/}
      {/*    </Card>*/}
      {/*</Box>*/}
      {/*<Box>*/}
      {/*    <Card>*/}
      {/*        <CardContent>*/}
      {/*            <ChequeContractStep3List*/}
      {/*                title={"چک های ورودی"}*/}
      {/*                cheques={props.secondCheque}*/}
      {/*            />*/}
      {/*        </CardContent>*/}
      {/*    </Card>*/}
      {/*</Box>*/}
    </Wrapper>
  );
};

export default ChequeContractStep3;
